import { createFileRoute } from "@tanstack/react-router";
import { AdminLayout } from "@/pages/admin/AdminLayout";
import Pages from "@/pages/admin/Pages";
import { buildSeoHead, publicPageSeo } from "@/data/seo";

export const Route = createFileRoute("/admin/pages")({
  head: () =>
    buildSeoHead(
      { ...publicPageSeo.home, key: "admin-pages", path: "/admin/pages", title: "Cloud Admin Pages", description: "Administrationsyta" },
      [],
      { noindex: true },
    ),
  component: () => <AdminLayout><Pages /></AdminLayout>,
});
